import STriangleAlert from "../../icons/triangle-alert.jsx";
import SSquareOpenNewWindows from "../../icons/square-open-new-windows.jsx";
import SSquareSelectedCheckBox from "../../icons/square-selected-check-box.jsx";
const ExpressiveReportCard = ({alert, noAlert, alertMessage, noAlertMessage, value, className, onOpen}) => {
  const variantClass = value ? "bg-linear-to-b from-[#FFDADA] to-white" : "bg-linear-to-b from-[#CEE7FF] to-white";

  return (
    <div
      className={["relative flex min-h-[120px] w-full flex-col justify-evenly gap-3 rounded border border-[#ededed] px-3 py-3 shadow-md transition-shadow hover:shadow-xl sm:px-4", variantClass, className, onOpen ? "cursor-pointer" : ""].filter(Boolean).join(" ")}
      onClick={onOpen}
      onKeyDown={(event) => {
        if (onOpen && (event.key === "Enter" || event.key === " ")) {
          event.preventDefault();
          onOpen();
        }
      }}
      role={onOpen ? "button" : undefined}
      tabIndex={onOpen ? 0 : undefined}>
      <div title="Materiais em cautela"
           className={["absolute top-3 right-3 flex size-7 items-center justify-center rounded-full bg-white shadow-sm transition-colors", value ? "text-[#8F0000]" : "text-[#063A6C]", onOpen ? "cursor-pointer" : ""].filter(Boolean).join(" ")}>
        <SSquareOpenNewWindows size={18} />
      </div>
      <div className={`flex items-center justify-center gap-2 text-base sm:text-lg ${value ?  "text-[#8F0000]" : "text-[#063A6C]"}`}>
        {value ? <STriangleAlert className="shrink-0" /> : <SSquareSelectedCheckBox  className="shrink-0"/>}
        <span className="min-w-0 break-words underline underline-offset-5">{value ? alert : noAlert}</span>
      </div>
      <div className="break-words text-center text-xs sm:text-sm">
        {value ? noAlertMessage : alertMessage}
      </div>
    </div>
  );
};

export default ExpressiveReportCard;
